import { Observable } from 'rxjs';
import { IdentityUser } from '../identity-user';
import { MenuHeader } from '../menu-header';

export abstract class IdentityRepository {
  abstract getUserInfo(): Observable<IdentityUser>;
  abstract getUserMenu(): Promise<MenuHeader>;
  abstract fullLogout(fullUrlLogout: string): void;
}
